export default "__VITE_ASSET__DRuIjj1r__"